import { TenantTranslate } from './tenantTranslate.model';

const tenantTranslateEN: TenantTranslate = {
  create: {
    title: 'Add a new organization',
    fields: {
      name: 'Organization name',
    },
    errors: {
      name: {
        required: 'Organization name is required',
        invalid: 'Organization name must be at least 3 characters',
      },
      conflict: 'Organization name already exists',
    },
    button: {
      create: 'Create',
    },
    success: 'Organization created successfully',
  },
  choose: {
    title: 'Select an organization',
  },
};

export default tenantTranslateEN;
